import React from 'react';

import DeleteIcon from '../../assets/icons/DeleteIcon';
import UploadIcon from '../../assets/icons/UploadIcon';

import Button from '../shared/Button';
import Select from '../shared/Select';

const RepeatingCountsFilters = (props) => {
  const {
    onAddClick,
    status,
    setStatus,
    statuses,
    onDelete,
    onUploadClick,
    deletePermission,
  } = props;

  return (
    <div className='settings-cmp__filters--main'>
      <div className='settings-cmp__actions'>
        <Button
          text='Add Count'
          type='submit'
          onClick={onAddClick}
        />

        <Button
          type='submit'
          width='60px'
          onClick={onUploadClick}
        >
          <UploadIcon color="#ffffff" />
        </Button>

        <Button
          type='icon'
          onClick={onDelete}
          disabled={!deletePermission}
        >
          <DeleteIcon style={{ color: '#000000' }}/>
        </Button>
      </div>

      <div className='settings-cmp__filters'>
        <Select
          value={status}
          onChange={setStatus}
          options={statuses}
          defaultLabel={`All Status (${statuses.length})`}
          width={180}
        />
      </div>
    </div>
  )
};

export default RepeatingCountsFilters;
